import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from "tss-react/mui";
import { Navigate } from 'react-router-dom';
import withRouter from './../../components/WithRouter';
import AppBar from '@mui/material/AppBar';
import Drawer from '@mui/material/Drawer';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import WidePrimaryButton from 'components/WidePrimaryButton';
import AppView from 'areas/shell/components/AppView';
import LocationDialog from 'areas/location/components/LocationDialog';
import { H1, H5, Body2 } from 'components/Typography';
import QRCodeReaderDialog from 'components/QRCodeReaderDialog';
import QRCodeScannerDialog from 'components/QRCodeScannerDialog';
import AuthenticationCodeDialog from 'areas/auth/components/AuthenticationCodeDialog';
import alertActions from 'areas/alert/actions';
import * as authActions from 'areas/auth/actions';
import { loadDivisionData } from 'areas/location/actions';
import classNames from 'classnames';
import isStringSet from 'utilities/is/isStringSet';
import styles from './styles';
import MediaQuery from 'react-responsive';
import FooterLink from 'components/FooterLink';
import HeaderLink from 'components/HeaderLink';
import FooterDivider from 'components/FooterDivider';
import QRGun from 'components/Icons/QRGun';
import CameraIcon from '@mui/icons-material/PhotoCamera';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import EventButton from 'components/EventButton';
import { browser } from 'components/BrowserSupport/';
import m from 'messages';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { appInsightsService } from "utilities/logging/appInsightsService";

const LoginPage = class extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            drawerOpen: false
        };
    }

    handleSendAuthCode = (sendSms, sendEmail) => {
        this.props.handleSendAuthCode(this.props.qrCode, sendSms, sendEmail);
    };

    updateDetails = () => {
        window.open(`${this.props.config.baseURL}/MySkillGuard`, "_blank");
    };

    confirmClicked = (authCode) => {
        this.props.continueAuthentication(this.props.qrCode, authCode);
    };

    handleVisitorPassScan = (qrCode, callback) => {
        this.props.showWarning(m.pages.login.cannotLogInWithVisitorPass, callback);
    };

    qrDialog = (qrCodeDialogOpen) => {
        return (
            <QRCodeReaderDialog
                title={m.scan.scanQrCodeTitle}
                open={!!qrCodeDialogOpen}
                onScanError={this.props.showWarning}
                handleClose={this.props.handleQrDialogClose}
                onVisitorPassScanned={this.handleVisitorPassScan}
                onCardScanned={this.props.authInitialise}
                config={this.props.config}
            />);
    };

    qrScannerDialog = (qrScannerDialogOpen) => {
        return (
            <QRCodeScannerDialog
                title={m.scan.scanQrCodeTitle}
                open={!!qrScannerDialogOpen}
                handleClose={this.props.handleQrDialogClose}
                onCardScanned={this.props.authInitialise}
                onScanError={this.props.showWarning}
                onVisitorPassScanned={this.handleVisitorPassScan}
                config={this.props.config} />
        );
    };

    authDialog = (authCodeDialogOpen) => {
        return (
            <AuthenticationCodeDialog
                open={authCodeDialogOpen}
                handleClose={this.props.handleAuthDialogClose}
                updateDetails={this.updateDetails}
                sendAuthCode={this.handleSendAuthCode}
                confirmClicked={this.confirmClicked}>
            </AuthenticationCodeDialog>
        );
    };

    locationDialog = (isLocationDialogOpen) => {
        return (
            <LocationDialog
                canCancel={false}
                handleClose={() => { }}
                onLoadDivisions={() => this.props.loadDivisions()}
                open={!!isLocationDialogOpen} />
        );
    };

    loginButtons = (classes) => {
        const appName = this.props.longTitle;
        const productName = this.props.sgAppName;
        return (
            <div>
                <H5 color="secondary" paragraph className={classes.loginTitle}>
                    {m.pages.login.loginHeader(appName)}
                </H5>
                <Body2 className={classes.loginMessage}>
                    {m.pages.login.loginMessage(productName)}
                </Body2>
                <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <WidePrimaryButton
                        className={classes.scanButton}
                        onClick={this.props.openQrCodeDialog}>
                        <span style={{ float: 'left' }}>
                            <CameraIcon />
                        </span>
                        {m.pages.login.useCamera}
                    </WidePrimaryButton>

                    {!browser.mobile &&
                        <WidePrimaryButton
                            className={classNames(classes.scanButton, classes.gunIcon)}
                            onClick={this.props.openQrScannerDialog}>
                            <span style={{ float: 'left' }}>
                                <QRGun />
                            </span>
                            {m.pages.login.useScanner}
                        </WidePrimaryButton>
                    }
                </div>
            </div>
        );
    };

    loginHeader = (isMobile) => {
        const { config } = this.props;
        return (
            <AppBar position="fixed" color="secondary" className={this.props.classes.loginBar} elevation={0} config={config}>
                <Toolbar className={this.props.classes.loginToolbar}>
                    <H1 className={classNames(this.props.classes.loginBarText)}>
                        {isMobile
                            ? <span>{this.props.shortTitle}</span>
                            : this.breakWord(this.props.longTitle)
                        }
                    </H1>
                    {!isMobile && this.navHeaderLinks()}
                    {!isMobile && <a href={this.props.sgAppLoginUrl}><img src={this.props.logo} alt="logo" className={this.props.classes.logo} /></a>}
                    {isMobile &&
                        <div style={{ position: 'absolute', right: 10 }}>
                            <EventButton onClick={this.toggleDrawer} color="inherit" variant="outlined">
                                Menu
                            </EventButton>
                        </div>
                    }
                </Toolbar>
            </AppBar>
        );
    };

    breakWord(title) {
        return (<span>{title}</span>);
    }

    toggleDrawer = () => {
        this.setState({ drawerOpen: !this.state.drawerOpen });
    };

    mobileDrawer = () => {
        const {
            classes,
            sgAppBaseUrl,
            sgAppName,
            myAppName,
            myAppUrl
        } = this.props;

        const goto = (url) => {
            window.location.href = url;
        };

        return (
            <Drawer
                open={this.state.drawerOpen}
                onClose={this.toggleDrawer}
                variant={this.state.drawerOpen ? "permanent" : "temporary"}
                anchor="top"
                className={classes.drawerPanel}
                ModalProps={{
                    keepMounted: true // Better open performance on mobile.
                }}
                PaperProps={{
                    className: classes.drawerPanel
                }}
            >
                <List>
                    <ListItem button className={classes.drawerListItem} onClick={() => goto(sgAppBaseUrl)}>
                        <a className={classes.drawerLink} href={sgAppBaseUrl}>{sgAppName}</a>
                    </ListItem>
                    <ListItem button className={classes.drawerListItem} onClick={() => goto(myAppUrl)}>
                        <a className={classes.drawerLink} href={myAppUrl}>{myAppName} </a>
                    </ListItem>
                    <ListItem button className={classes.drawerListItem}>
                        <a className={classes.drawerLinkActive} href="/">{this.props.longTitle}</a>
                    </ListItem>
                </List>
            </Drawer>
        );
    };

    navHeaderLinks() {
        const {
            classes,
            sgAppBaseUrl,
            sgAppName,
            myAppName,
            myAppUrl,
            mobileApp,
            mobileAppUrl
        } = this.props;
        return (
            <ul className={classes.headerUL}>
                <HeaderLink href={sgAppBaseUrl} text={sgAppName} hideOnMobile={true} />
                <HeaderLink href={myAppUrl} text={myAppName} hideOnMobile={true} />
                <HeaderLink href="/" text={this.props.longTitle} hideOnMobile={true} active={true} />
                <HeaderLink href={mobileAppUrl} text={mobileApp} hideOnMobile={true} />
            </ul>
        );
    }

    footer() {
        const {
            classes,
            sgAppBaseUrl,
            hasLeftFooterImage,
            hasRightFooterImage,
            rightFooterImage,
            leftFooterImage } = this.props;

        const footerClasses = classNames(classes.footer, classes.footerWithImages);

        let userGuideURL = "/api/v1/user-guide";
        let userGuideText = "User Guide";
        const externalHelpEnabled = this.props.config.externalHelpEnabled;
        if (externalHelpEnabled) {
            userGuideURL = this.props.config.externalMobileAppsHelpURL;
            userGuideText = "Help Centre";
        }

        return (
            <footer className={footerClasses}>
                {hasLeftFooterImage && <img src={leftFooterImage} className={classes.footerImage} />}
                {!hasLeftFooterImage && <div></div>}
                <ul className={classes.footerUl}>
                    <FooterLink text={`&copy; ${new Date().getFullYear()}`} />
                    <FooterLink href="https://www.causeway.com" text="Causeway Technologies Limited" />
                    <FooterDivider />
                    {!externalHelpEnabled && 
                        <>
                            <FooterLink href={`${sgAppBaseUrl}/contact`} text="Contact Us" hideOnMobile={true} />
                            <FooterDivider />
                        </>
                    }
                    <FooterLink href={`${sgAppBaseUrl}/privacy`} text="Privacy Policy" hideOnMobile={true} />
                    <FooterDivider />
                    <FooterLink href={`${sgAppBaseUrl}/termsandconditions`} text="Terms & Conditions" hideOnMobile={true} />
                    <FooterDivider />
                    <FooterLink href={userGuideURL} text={userGuideText} target="_blank" hideOnMobile={false} />
                </ul>
                {hasRightFooterImage && <img src={rightFooterImage} className={classes.footerImage} />}
                {!hasRightFooterImage && <div></div>}
            </footer>
        );
    }

    render() {
        const {
            classes,
            config,
            isQrDialogOpen,
            isQrScannerDialogOpen,
            isAuthCodeDialogOpen,
            isLocationDialogOpen,
            shouldRedirect } = this.props;

        if (shouldRedirect) {
            return (<Navigate to='/' />);
        }

        return (
            <MediaQuery maxWidth={1200}>
                {(isMobile) =>
                    <AppView
                        title={m.pages.login.title(config.appName)}
                        appBar={this.loginHeader(isMobile)}
                        hideNavigation={true}
                        contentClass={classes.loginContent}>
                        {this.qrDialog(isQrDialogOpen)}
                        {this.qrScannerDialog(isQrScannerDialogOpen)}
                        {this.authDialog(isAuthCodeDialogOpen)}
                        {this.locationDialog(isLocationDialogOpen)}
                        <main className={classes.main}>
                            {isMobile && this.mobileDrawer()}
                            <Grid container style={{ flex: 1 }} className={classes.loginContainer}>
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" justifyContent="center" direction="row">
                                        <div className={classes.panel}>
                                            {this.loginButtons(classes)}
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {this.footer()}
                        </main>
                    </AppView>
                }
            </MediaQuery>
        );
    }
};

function mapStateToProps(state) {
    const {
        auth,
        config,
        location
    } = state;

    const isQrDialogOpen = auth.qrCodeDialogOpen;
    const isQrScannerDialogOpen = auth.qrScannedDialogOpen;
    const isAuthCodeDialogOpen = auth.authCodeDialogOpen && isStringSet(auth.qrCode);
    const isLocationDialogOpen = auth.loggedIn && !location.valid;
    const shouldRedirect = auth.loggedIn && location.valid;

    const hasLeftFooterImage = isStringSet(config.footerLeftImage) && config.footerLeftImage.indexOf(".") > 0;
    const hasRightFooterImage = isStringSet(config.footerRightImage) && config.footerRightImage.indexOf(".") > 0;

    return {
        config,
        longTitle: config.appName,
        shortTitle: config.shortAppName,
        qrCode: auth.qrCode,
        loggedIn: auth.loggedIn,
        shouldRedirect,
        logo: `/${config.theme}/${config.headerImageFilename}?dummy=2`,
        hasLeftFooterImage,
        leftFooterImage: `/${config.theme}/${config.footerLeftImage}`,
        hasRightFooterImage,
        rightFooterImage: `/${config.theme}/${config.footerRightImage}`,
        isQrDialogOpen,
        isQrScannerDialogOpen,
        isAuthCodeDialogOpen,
        isLocationDialogOpen,
        sgAppBaseUrl: config.homePageUrl,
        sgAppLoginUrl: `${config.homePageUrl}/SkillSafe/Account/LogOn`,
        sgAppName: config.productName,
        myAppUrl: `${config.baseURL}/MySkillGuard`,
        myAppName: config.myProductName,
        mobileApp: 'Mobile App',
        mobileAppUrl: `${config.baseURL}/SkillSafe/Account/MobileApp`
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadDivisions: () => dispatch(loadDivisionData()),
        showWarning: (message, callback) => dispatch(alertActions.warn(message, callback)),
        authInitialise: (qrCode, callback) => dispatch(authActions.initialise(qrCode, callback)),
        continueAuthentication: (qrCode, authCode) => dispatch(authActions.continueAuthentication(qrCode, authCode)),
        handleSendAuthCode: (qrCode, sendSms, sendEmail) => dispatch(authActions.sendCode(qrCode, sendEmail, sendSms)),
        openQrCodeDialog: () => dispatch(authActions.openQrDialog()),
        openQrScannerDialog: () => dispatch(authActions.openQrScannerDialog()),
        handleQrDialogClose: () => dispatch(authActions.closeQrDialog()),
        openAuthCodeDialog: () => dispatch(authActions.openAuthCodeDialog()),
        handleAuthDialogClose: () => dispatch(authActions.closeAuthCodeDialog())
    };
}

const styledLoginPage = withStyles(LoginPage, styles);
const routedLoginPage = withRouter(styledLoginPage);
const connectedLoginPage = connect(mapStateToProps, mapDispatchToProps)(routedLoginPage);

export default withAITracking(appInsightsService.reactPlugin, connectedLoginPage, "Login Page", "LoginPage");